/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/24/19
 * Time: 10:17 AM
 */
import React,{Component} from 'react';
import './BuildingUpdate.css';
import {Col, Row} from "reactstrap";
import DrpDwn from "../../../../../components/Dropdown/Dropdown/DrpDwn";
import Modal from "../../../../../components/Modal/Modal";
// import Lbl from "../../../../../components/Label/Lbl";
// import GoogleLocation from "../../../../../components/GoogleLocation/GoogleLocation";
import {Checkbox, Form, Button} from "semantic-ui-react";
import LabelInput from "../../../../../components/Input/Input/TxtLbl";
import $ from "jquery";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../../axios/axios_api_services";

class App extends Component{
  state = {
    branch_list: [],
    branch_id: '',
    building_name: '',
    building_code: '',
    building_location: null,
    building_status: true,
  };

  fillData = () => {
    let data = this.props.data;
    this.setState({
      branch_id: data.branchId,
      building_name: data.name,
      building_code: data.code,
      // building_location: data.location,
      building_status: data.status==="AVAILABLE",
    });
  };
  dropDownChange = name => (event, {value}) => {
    switch (name) {
      case 'branch':
        this.setState({
          branch_id: value
        });
        break;
      default:
        break;
    }
  };
  getAllBranch = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            branch_list: response.data.branchList
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  handleChange = name => event => {
    let value = event.target.value;

    this.setState({
      [name]: value
    });
  };
  componentDidMount() {
    $('input').attr('autocomplete', 'off');
    this.getAllBranch();
    this.fillData();
  }
  handleChange_ = building_location => {
    this.setState({building_location});
  };
  handleSelect_ = building_location => {
    this.setState({building_location});
  };

  addressHandler_ = (building_location) => {
    this.setState({building_location});
  };

  isValidate = () => {
    let name = this.state.building_name.trim();
    let code = this.state.building_code.trim();
    let location = this.state.building_location;
    let branch_id  = this.state.branch_id;
    let status = this.state.building_status ? "AVAILABLE":"UNAVAILABLE";

    const obj = {
      buildingId: this.props.data.buildingId,
      branchId: branch_id,
      name: name,
      location: location,
      code: code,
      status: status
    };

    if(name === '' || code === '' || location === ''){
      common.notifyMessage("Please select all required fields");
    }else{
      swal({
        title: "Do you want to update building?",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            this.sendToBackend(obj);
            break;
        }
      });
    }
  };

  sendToBackend = (obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);

    axiosTags.post(apiConfig.CORPORATES_BRANCH_BUILDING, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert(response.data.message, 0);
          this.props.closeModal("building_modal", false);
          this.props.refreshData();

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    let rows = [];
    if (this.state.branch_list.length !== 0) {
      this.state.branch_list.map((row, index) => {
        rows.push(
          {
            key: index,
            text: row.name,
            value: row.branchId
          }
        )
      });
    }
    return (
      <Modal isOpen={true} toggle={() => this.props.closeModal("building_modal", false)} size="md" header="Edit Building Details">
        <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
          <Row>
            <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
              <Row>
                <Col lg={12}>
                  <Form>
                    <Form.Group widths='equal'>
                      <DrpDwn
                        required
                        tagText={"Branch"}
                        placeholder={"Branch"}
                        options={rows}
                        value={this.state.branch_id}
                        onChange={this.dropDownChange('branch')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <LabelInput
                        required
                        tagText={"Building"}
                        placeholder={"Building Name"}
                        value={this.state.building_name}
                        onChange={this.handleChange('building_name')}
                      />
                    </Form.Group>

                    <Form.Group widths='equal'>
                      <LabelInput
                        required
                        tagText={"Code"}
                        placeholder={"Building Code"}
                        value={this.state.building_code}
                        onChange={this.handleChange('building_code')}
                      />
                    </Form.Group>
                  </Form>

                  <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                            checked={this.state.building_status} onChange={()=>this.setState({ building_status: !this.state.building_status })} toggle
                            label={this.state.building_status ? 'Available Building' : 'Unavailable Building'}/>

                </Col>

                <Col lg={6}>
                  <Form>

                    {/*<Row>*/}
                      {/*<Col sm={12}>*/}
                        {/*<Lbl marginTop={"0px"} required>Location</Lbl>*/}
                        {/*<GoogleLocation placeholder={"Select location"} location={this.state.building_location}*/}
                                        {/*handleChange_={this.handleChange_} handleSelect_={this.handleSelect_}*/}
                                        {/*addressHandler_={this.addressHandler_}/>*/}

                      {/*</Col>*/}
                    {/*</Row>*/}
                  </Form>
                </Col>

              </Row>

            </Col>

            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <center>
                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px',marginTop:'25px'}}>
                  <Button className="px-5" onClick={this.isValidate}>Update Building</Button>
                </Col>
              </center>

            </Col>

          </Row>

        </Col>
      </Modal>
    );
  }
}
const mapStateToProps = (state) => ({
  table_data: state.COPLocationReducer.table_data,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addFloor: (data) => dispatch(actionCreator.addFloor(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
